<template>
  <div>
    <v-card class="card-shadow border-radius-xl pa-6">
      <div class="pb-4">
        <h6 class="text-typo text-h6 font-weight-bold">Ajouter un attribut</h6>
      </div>
      <div v-if="loading" class="grid-center-h-v">
        <v-progress-circular
          :size="32"
          :width="2"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-card-text v-else>
        <div class="mb-4">
          <label class="text-xs text-typo font-weight-bolder ms-1">NOM</label>
          <v-text-field
            v-model="name"
            hide-details
            outlined
            color="rgba(0,0,0,.6)"
            light
            placeholder=""
            class="
              font-size-input
              placeholder-lighter
              border border-radius-md
              text-light-input
            "
          ></v-text-field>
        </div>
        <div class="my-4">
          <label class="text-xs text-typo font-weight-bolder ms-1">POIDS</label>
          <v-text-field
            type="number"
            v-model.number="weight"
            hide-details
            outlined
            color="rgba(0,0,0,.6)"
            light
            placeholder=""
            class="
              font-size-input
              placeholder-lighter
              border border-radius-md
              text-light-input
            "
          ></v-text-field>
        </div>
        <div class="my-4">
          <label class="text-xs text-typo font-weight-bolder mr-4"
            >ATTRIBUABLE À UN VÉHICULE</label
          >
          <v-switch
            :ripple="false"
            class="d-inline-flex mt-0 pt-0 switch ms-auto"
            v-model="isVehicle"
            hide-details
            color="#3a416ff2"
            inset
          ></v-switch>
        </div>
        <BtnBlue
          :btnTitle="editAttribut ? $t('appButton.edit') : $t('appButton.save')"
          :disabled="canCreate"
          @clicked="postAttribute"
        ></BtnBlue>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BtnBlue from "../common/BtnBlue.vue";

export default {
  name: "ClientAttributesCreate",

  components: {
    BtnBlue,
  },

  props: {
    editAttribut: {
      type: [Object, null],
      default: null,
    },
  },

  created() {
    if (this.editAttribut) {
      this.mapState(this.editAttribut);
    }
  },

  data() {
    return {
      id: null,
      name: "",
      weight: 1,
      isVehicle: false,
      loading: false,
    };
  },

  computed: {
    canCreate() {
      return (
        this.name.length > 0 &&
        !this.name.includes(",") &&
        !isNaN(Number(this.weight)) &&
        typeof this.weight == "number"
      );
    },
  },

  watch: {
    editAttribut(nVal) {
      if (nVal) {
        this.mapState(nVal);
      } else {
        this.initState();
      }
    },

    weight(nVal) {
      if (typeof nVal == "string") {
        this.weight = null;
      }
    },
  },

  methods: {
    async postAttribute() {
      this.loading = true;
      const attributes = {
        name: this.name.trim(),
        weight: Number(this.weight),
        isVehicle: this.isVehicle,
        ...(this.id ? { id: this.id } : {}),
      };
      await this.$store.dispatch("post_attributes", attributes);
      this.loading = false;
      this.initState();
      this.$emit("closeDialog");
    },

    initState() {
      this.id = null;
      this.name = "";
      this.weight = 0;
      this.isVehicle = false;
      this.loading = false;
    },

    mapState(item) {
      this.id = item.id;
      this.name = item.name;
      this.weight = item.weight;
      this.isVehicle = item.isVehicle;
    },
  },
};
</script>

<style scoped></style>
